import type { components } from "~/types/entity/emerIntwcApiWeb.schema";

export type Cookie2Token = components["schemas"]["V2IssueTokenResponseBody"]
// export type Cookie2Token = {
//   access_token: string
//   token_type: string
//   id_token: string
//   expires_in: number
// }
export type Role = components["schemas"]["会員区分enum"]
/**
 * ここに含まれない Role を State に入れて管理しない
 * Staff = スタッフSilver(8) 保持者 (表示名「準備会」)。3分時限閲覧の対象外=サークル系を無制限閲覧可
 * (2026-07-06 権限再編。Documents/Plan/Trial3minutes/Plan20260706.md)
 */
export const validRoleList: Array<Role> = ["Platinum", "Gold", "Silver", "Staff", "Bronze", "FreeRenewal"];
/**
 * ここに含まれない Role を表示しない
 */
export const displayRoleList: Array<Role> = ["Platinum", "Gold", "Silver", "Staff", "FreeRenewal"];

/**
 * 会員区分の表示名。C#/OpenAPI 名称は Staff だが、クライアントの表示は「準備会」にする
 * (2026-07-06 権限再編。Documents/Plan/Trial3minutes/Plan20260706.md Q-P10)。他の Role はそのまま表示する。
 */
export const roleDisplayName = (role: Role | string | undefined): string | undefined =>
  role === "Staff" ? "準備会" : role;
// https://dev.azure.com/cosat/Circlems/_git/ComikeWebCatalog?path=%2Fclient-app%2Fsrc%2Futils%2FurlHelper.ts
// において画面ごとの権限表として記述している
// export const authorizatedRoles: Array<Role> = ["Platinum", "Gold"];

// mapped type 内の型式を VSCode ホバーで簡約表示するためのヘルパー
type _Prettify<T> = { [K in keyof T]: T[K] extends infer V ? V : never } & {}
// V2UserInfoItem の各プロパティを必須化し null を除去したもの。birthdate のみ undefined を許容する（null は不許可）
export type UserInfo = _Prettify<
  { [K in keyof components["schemas"]["V2UserInfoItem"] as K extends "birthdate" ? never : K]-?: NonNullable<components["schemas"]["V2UserInfoItem"][K]> }
  & { birthdate: string | undefined }
>
// UserInfo が 依然としてV2UserInfoItem を満たすことをコンパイル時に検証する
// export は noUnusedLocals 警告対応
export type _UserInfoSatisfiesV2UserInfoItem = UserInfo extends components["schemas"]["V2UserInfoItem"] ? true : never

export type AuthTokenState = "Authenticated" | "NoIdToken" | "FailEntraId2Token" | "FailCookie2Token" | "NoActiveUser";

export type AuthToken = {
  accessToken: string
  expiresAt: number | undefined
  iat: number | undefined
  // id_token の entitlements クレーム(数値スペース区切り)。3分時限閲覧(12)の有無判定に使う。
  // (Documents/Plan/Trial3minutes/Plan20260706.md / ADR-012)
  entitlements?: string
  loginAttemptAt: number
  authTokenState: AuthTokenState
  error?: string
}

// 3分間 時限閲覧 (2026-07-06 権限再編。Documents/Plan/Trial3minutes/Plan20260706.md / ADR-012)
// entitlements に現れる ユーザー権限enum の数値 (サーバー側 時限閲覧=12 (旧称 トライアルSilver)。
// 旧 トライアルGold=13 は enum ごと全廃 (13 は欠番))
export const TRIAL_VIEW_ENTITLEMENT = "12";
// サーバー定数と一致させる (V2Constants.TrialActive=3分 / TrialBlockedAfterExpiry=5分 / TrialCooldown=8分)
// 【値の同期】Emer.IntwcApi/Emer.IntwcApi.Core/Models/V2/V2Constants.cs の TrialActive と同じ値にすること (変更時は相互に修正する)
export const TRIAL_ACTIVE_SEC = 3 * 60;
// 3分終了後のブロック時間 (5分でリセット。Plan20260706 Q-P2)
// 【値の同期】Emer.IntwcApi/Emer.IntwcApi.Core/Models/V2/V2Constants.cs の TrialBlockedAfterExpiry と同じ値にすること (変更時は相互に修正する)
export const TRIAL_BLOCKED_SEC = 5 * 60;
// 1サイクル = 8分 (付与からリセットまで)
export const TRIAL_CYCLE_SEC = TRIAL_ACTIVE_SEC + TRIAL_BLOCKED_SEC;
// 権限 Silver は 15分利用 + 5分ブロック = 20分サイクル (ADR-021。V2Constants.TrialActiveSilver / TrialCooldownSilver と一致させる)
// 【値の同期】Emer.IntwcApi/Emer.IntwcApi.Core/Models/V2/V2Constants.cs の TrialActiveSilver と同じ値にすること (変更時は相互に修正する)
export const TRIAL_ACTIVE_SEC_SILVER = 15 * 60;
export const TRIAL_CYCLE_SEC_SILVER = TRIAL_ACTIVE_SEC_SILVER + TRIAL_BLOCKED_SEC;

export type UserState = {
  userInfo: UserInfo // | undefined // 未ログイン時も undefined は許可せず 未ログイン状態の UserInfo を格納する
  token: AuthToken | undefined
}

export type AccessTokenWithLoginOption = {
  // cacheBustT: 強制再取得用の時刻 (ミリ秒。Date.now())。指定時はトークン取得 POST のキャッシュを無効化する
  getAccessTokenWithLogin: (cacheBustT?: number) => Promise<string | undefined>
  // getValidAuthToken: () => AuthToken | undefined
  // setUserState: (token: AuthToken | undefined, userInfoItem: components["schemas"]["V2UserInfoItem"] | undefined) => void
}
